import { Button } from '@navi/web-ui/lib/primitives';
import React, { useEffect, useState } from 'react';
import NoTicketsFound from './components/NoTicketsFound';
import CreateTicketDrawer from './components/CreateTicketDrawer';
import TicketRequestsView from './components/TicketRequestsView';
import styles from './index.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchRequestRaisedTickets,
  fetchRequestReceivedTickets
} from './actions/CsaTicketingActions';
import { RootState } from '@cp/src/store';
import LoaderIcon from '@cp/src/assets/icons/LoaderIcon';
import { useParams } from 'react-router-dom';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { createKey } from '@cp/utils/CaseDetail.utils';
import { Roles } from '@cp/pages/auth/constants/AuthConstants';

const CsaTicketing = () => {
  const dispatch = useDispatch();
  const { loanId = '', customerId = '' } = useParams();
  const [isRequestFormOpen, setIsRequestFormOpen] = useState(false);

  const requestRaised = useSelector((state: RootState) => state?.csaTicketing?.requestRaised);
  const requestReceived = useSelector((state: RootState) => state?.csaTicketing?.requestReceived);
  const userId = useSelector((state: RootState) => state?.common?.userData?.referenceId) || '';
  const userRoles = useSelector((state: RootState) => state?.common?.userData?.roles);
  const editAccessFlag = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.details?.data?.editAccessFlag
  );
  const isGlobalAccessGiven = userRoles?.includes(Roles.ROLE_GLOBAL_ACCESS);
  const disableCTAs = isGlobalAccessGiven ? !editAccessFlag : false;
  const { tickets: requestReceivedData, isLoading: isRequestReceivedLoading } =
    requestReceived || {};
  const { tickets: requestRaisedData, isLoading: isRequestRaisedLoading } = requestRaised || {};

  useEffect(() => {
    dispatch(fetchRequestReceivedTickets({ userId, loanId }));
    dispatch(fetchRequestRaisedTickets({ userId, loanId }));
  }, []);

  const toggleRequestFormDrawer = () => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_CREATE_TASK_CLICKED);
    setIsRequestFormOpen(prev => !prev);
  };

  if (isRequestRaisedLoading || isRequestReceivedLoading)
    return (
      <div className={styles.loader}>
        <LoaderIcon
          size={42}
          borderWidth={5}
          borderColor="var(--text-primary)"
          fillColor="var(--blue-base)"
        />
      </div>
    );
  const totalTickets = requestRaisedData?.length + requestReceivedData?.length;

  return (
    <div className="relative">
      {totalTickets ? (
        <div className={styles.ticketRequestViewWrapper}>
          <TicketRequestsView />
          <div className={styles.buttonContainer}>
            <Button
              onClick={toggleRequestFormDrawer}
              type="submit"
              variant="primary"
              disabled={disableCTAs}
              fullWidth
            >
              Create new task
            </Button>
          </div>
        </div>
      ) : (
        <NoTicketsFound toggleRequestFormDrawer={toggleRequestFormDrawer} />
      )}
      <CreateTicketDrawer isOpen={isRequestFormOpen} toggleDrawer={toggleRequestFormDrawer} />
    </div>
  );
};

export default React.memo(CsaTicketing);
